const blogCardDateFormatter = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  timeZone: 'Europe/Rome',
});

export const formatBlogCardDate = (value?: string | null) =>
  value ? blogCardDateFormatter.format(new Date(value)) : null;
